<ng-container *ngIf="(userInfo && !loading); else waiting">
    <div class="row">
         <!-- sezione ricerca -->
         <app-advanced-search [customSearch]="advSearch.getConfigAdv()" (callSearch)="searchParams($event)" (callButton)="callButton($event)"></app-advanced-search>
         <div *ngIf="primaRicerca">
            <h5 title="Rimuovere i filtri di ricerca renderà la ricerca molto lenta e potrebbe non restituire risultati in quanto la richiesta va in timeout">Ricerca di default attivata - vengono mostrati i documenti dell'anno corrente {{this.anno}}</h5>
        </div>
         <hr>
    </div>

    <ng-container *ngIf='dataTable; else waiting'>
        <div class="row" style="margin-bottom: 10px;" *ngIf="dataTable.length > 0">

        </div>
    </ng-container>

    <ng-template #noRes>
        <div>
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
        </div>
    </ng-template>
</ng-container>

<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>